export const normalizeMsisdn = (mobileNumber) => {
    const normalized = String(mobileNumber || '')
        .replace(/\s+/g, '')
        .replace(/[()-]/g, '');

    if (!normalized) {
        return null;
    }

    let digits = normalized.replace(/^\+/, '');
    let internationalNumber = digits;

    if (/^0[789]\d{9}$/.test(digits)) {
        internationalNumber = `234${digits.slice(1)}`;
    } else if (/^[789]\d{9}$/.test(digits)) {
        internationalNumber = `234${digits}`;
    } else if (/^234[789]\d{9}$/.test(digits)) {
        internationalNumber = digits;
    } else {
        return null;
    }

    if (!/^234[789]\d{9}$/.test(internationalNumber)) {
        return null;
    }

    return internationalNumber;
};

export default normalizeMsisdn;